import React, { useContext, useMemo } from 'react'
import { ElementContext } from '../../../cnr/contexts/ElementContext'
import { Label, Icon } from 'semantic-ui-react'

const CardGameInfo = () => {

  // elementContextf
  const elementContext = useContext(ElementContext)
  const { element_state } = elementContext ?? {}
  const { itemData } = element_state ?? {}

  const gamesByNumber = useMemo(() => {
    const grouped = {};

    _.forEach(itemData, (value, propKey) => {
      const match = propKey.match(/(game)(\d+)/);
      if (match) {
        const [, baseKey, number] = match;
        if (!grouped[number]) grouped[number] = {};
        grouped[number][baseKey] = value;
      }
    });

    return grouped;
  }, [itemData]);

  const lbls = _.map(gamesByNumber, (item, itemNumber) => {
    const { game } = item
    return <Label size='small' color={game ? 'green' : 'grey'}>
      <Icon name='hashtag' />{itemNumber}
    </Label>
  })

  return (
    <div style={{ display: 'flex', gap: '.25em', marginBottom: '.5em' }}>{lbls}</div>
  )
}

export default CardGameInfo
